import { graphql } from 'gql.tada';
import { useMutation } from '@apollo/client';

const StartStripeConnectMutation = graphql.persisted(
  "StartStripeConnect",
  graphql(`
    mutation StartStripeConnect($input: StartStripeConnectInput!) {
      startStripeConnect(input: $input) {
        onboardingUrl
        stripeAccount {
          id
          status
          connected
          active
          chargesEnabled
          payoutsEnabled
          onboardingComplete
        }
        userErrors {
          message
          path
        }
      }
    }
  `)
);

export { StartStripeConnectMutation };

export function useStartStripeConnect() {
  return useMutation(StartStripeConnectMutation);
}
